export default "__VITE_PUBLIC_ASSET__5c7ee5a0__"